import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format datetime to show date on top and time below (to save width)
 */
export function formatDateTimeCompact(dateString: string | null | undefined): { date: string; time: string } {
  if (!dateString) {
    return { date: 'N/A', time: '' }
  }
  
  try {
    const date = new Date(dateString)
    // Format as yyyy-mm-dd
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const dateStr = `${year}-${month}-${day}`
    const timeStr = date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false 
    })
    return { date: dateStr, time: timeStr }
  } catch (error) {
    return { date: 'Invalid', time: '' }
  }
}
